//  Angular imports
import { Injectable } from '@angular/core';
//  Application imports
import { FortiCloudBaseProvisioningService } from './base-provisioning.service';
import { Endpoints } from './endpoints';
//  Third party imports
import { Observable } from 'rxjs';
import { RMetricData } from 'app/records/metric-data.record';
import { RStorageDataRow } from 'app/records/storage-data.record';

@Injectable({
    providedIn: 'root'
})
export class MetricsService extends FortiCloudBaseProvisioningService {
    public getMetrics(accountId: number, serialNumber: string,
        metric: string, time: string): Observable<Array<RMetricData>> {
        return this.apiGet<RMetricData>(
            `${Endpoints.METRICS}/${accountId}/${serialNumber}?metric=${metric}&time=${time}`,
            RMetricData
        ) as Observable<Array<RMetricData>>;
    }

    public getStorageMetrics(accountId: number, serialNumber: string): Observable<RStorageDataRow> {
        return this.apiGet<RStorageDataRow>(
            `${Endpoints.METRICS}/storage/${accountId}/${serialNumber}`,
            RStorageDataRow
        ) as Observable<RStorageDataRow>;
    }
}
